import * as yup from 'yup'

import { DebitCardType } from '@/types/card'

export const cardSelectionSchema = yup.object().shape({
  card_type: yup
    .string()
    .oneOf(DebitCardType, 'Invalid debit card type')
    .required('Debit card type is required'),
})

export type CardSelectionSchema = yup.InferType<typeof cardSelectionSchema>
